import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
export default ItemsV3Serializer.extend({
  attrs: {
    productSetsAll: {
      serialize: 'ids',
      deserialize: 'ids'
    },
    productSetsAny: {
      serialize: 'ids',
      deserialize: 'ids'
    },
    requiredCategories: {
      serialize: 'ids',
      deserialize: 'ids'
    },
    requiredItems: {
      serialize: 'ids',
      deserialize: 'ids'
    },
    requiredItemVariations: {
      serialize: 'ids',
      deserialize: 'ids'
    },
    requiredSurcharges: {
      serialize: 'ids',
      deserialize: 'ids'
    },
    allowedCategories: {
      serialize: 'ids',
      deserialize: 'ids'
    },
    allowedItems: {
      serialize: 'ids',
      deserialize: 'ids'
    },
    allowedItemVariations: {
      serialize: 'ids',
      deserialize: 'ids'
    },
    allowedSurcharges: {
      serialize: 'ids',
      deserialize: 'ids'
    }
  },
  keyForRelationship(key, relationship) {
    if (key === 'allowedCategories') {
      return 'allowed_category_ids';
    } else if (key === 'requiredCategories') {
      return 'required_category_ids';
    } else if (key === 'productSetsAll') {
      return 'product_set_all_ids';
    } else if (key === 'productSetsAny') {
      return 'product_set_any_ids';
    } else {
      return this._super(key, relationship);
    }
  }
});